import { UseQueryResult, useQuery } from 'react-query';
import { GetUserFeatureUsageResponse } from '@cbinsights/adminservice/adminservice';
import { GetUserFeatureUsage } from '.';
import { getUserFeatureUsage } from '../api/GetUserFeatureUsage';

type Params = Parameters<typeof getUserFeatureUsage>[0];
type Return = GetUserFeatureUsageResponse;

export const useGetUserFeatureUsage = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetUserFeatureUsage, Params]>(
    ['GetUserFeatureUsage', params],
    () => getUserFeatureUsage(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
